import { createApi } from "@reduxjs/toolkit/query/react";
import { nodeUrl } from "../../views/Apis";
import { axiosBaseQuery } from "../axiosBaseQuery";

export const matchAPI = createApi({
  reducerPath: "matchAPI",
  baseQuery: axiosBaseQuery({ baseUrl: nodeUrl }),
  endpoints: () => ({}),
});
